const careOppsReducer = (state, action) => {
    const { type } = action;
    switch (type) {
      case "update":
        break;        
      default:
        throw new Error();
    }
  };

  export {careOppsReducer};